import React from "react";

/** Pill with a coloured dot: success, warning, danger, info or muted. */
function StatusBadge({ tone = "muted", children }) {
  return <span className={`kv-badge kv-badge--${tone}`}>{children}</span>;
}

export default StatusBadge;
